import type { ColumnsType } from "antd/es/table";
import { Button } from "antd";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";

export const AREACODEMAP = {
  'US': {
    kode: '1',
    length: 10
  },
  'CN': {
    kode: '86',
    length: 11
  },
  'JP': {
    kode: '81',
    length: 10
  },
  'KR': {
    kode: '82',
    length: 10
  },
  'GB': {
    kode: '44',
    length: 10
  },
  'DE': {
    kode: '49',
    length: 10,
    maxLength: 11
  },
  'FR': {
    kode: '33',
    length: 9
  },
  'IT': {
    kode: '39',
    length: 10
  },
  'ES': {
    kode: '34',
    length: 9
  },
  'CA': {
    kode: '1',
    length: 10
  },
  'AU': {
    kode: '61',
    length: 9
  },
  'NZ': {
    kode: '64',
    length: 8,
    maxLength: 10
  },
  'SG': {
    kode: '65',
    length: 8
  },
  'MY': {
    kode: '60',
    length: 9,
    maxLength: 10
  },
  'TH': {
    kode: '66',
    length: 9
  },
  'HK': {
    kode: '852',
    length: 8
  },
  'TW': {
    kode: '886',
    length: 9
  },
  'IN': {
    kode: '91',
    length: 10
  },
  'BR': {
    kode: '55',
    length: 9
  },
  'VN': {
    kode: '84',
    length: 9
  },
  'ID': {
    kode: '62',
    length: 10,
    maxLength: 11
  },
  'KH': {
    kode: '855',
    length: 8,
    maxLength: 9
  },
  'TR': {
    kode: '90',
    length: 10
  },
  'MM': {
    kode: '95',
    length: 10
  },
  'AE': {
    kode: '971',
    length: 9
  },
} as const;

export const DEFAULT_QUERY_DATA = {
    Email: null,
    MemberId: null,
    MemberEmail: null
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '持卡人邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '用户邮箱',
            type: "input",
            field: "MemberEmail",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef } = props;
    
    return [
        {
            title: '邮箱',
            dataIndex: "Email",
        },
        {
            title: 'FirstName',
            dataIndex: "FirstName",
        },
        {
            title: 'LastName',
            dataIndex: "LastName",
        },
        {
            title: '手机号',
            dataIndex: "PhoneNumber",
        },
        {
            title: '国家',
            dataIndex: "Country",
        },
        {
            title: '城市',
            dataIndex: "City",
        },
        {
            title: '州、县、省或地区',
            dataIndex: "State",
        },
        {
            title: '地址行 1',
            dataIndex: "Line1",
        },
        {
            title: '邮编',
            dataIndex: "PostalCode",
        },
        {
            title: '卡片数量',
            dataIndex: "CardsCount",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (_, record: any) => {
                return (
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            operationRef?.current?.changeVisible?.(record, 'update');
                        }}
                    >
                        修改信息
                    </Button>
                );
            },
        },
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    const { formData, phoneRules } = props;
    
    return [
        {
            title: '邮箱',
            type: "input",
            field: "Email",
            rules: [
                {
                    type: 'email',
                    message: '请输入有效的邮箱地址',
                },
            ],
        },
        {
            title: '手机号',
            type: "input",
            field: "PhoneNumber",
            rules: [
                {
                    pattern: /^[0-9]+$/,
                    message: '手机号只能包含数字',
                },
                {
                    validator: (_: any, value: string) => {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const min = phoneRules?.min || 8;
                        const max = phoneRules?.max || 15;
                        if (value.length < min || value.length > max) {
                            if (min === max) {
                                return Promise.reject(`手机号长度应为 ${min} 位`);
                            } else {
                                return Promise.reject(`手机号长度应在 ${min}-${max} 位之间`);
                            }
                        }
                        return Promise.resolve();
                    },
                },
            ],
        },
    ];
}


